import type { KeyboardInputType } from '@infield/providers/device-provider/device-context';
import type { ChangeEvent } from 'react';

// this constants are used to determine if the input is valid or not and will
// block these inputs from being written to timeseries. The logic of the input when
export const INVALID_NUMERIC_INPUTS = ['-', '.', '-.', '.-', undefined];

// Regex pattern that is used by input to validate the numeric value.
export const noLetters = (inputValue: string) => {
  return /^[0-9.\-]*$/.test(inputValue);
};

export const handleChangeInputValue = (
  e: ChangeEvent<HTMLInputElement>,
  setReadingInput: (value: string | undefined | null) => void,
  keyboardConfigType: KeyboardInputType
) => {
  if (e.target.validity.valid) {
    setReadingInput(e.target.value);
  } else if (keyboardConfigType === 'number' && !e.target.validity.valid) {
    // this is to adhere to the logic of the input when it has the type 'number'.
    // For the input to show numbers that are not valid , it will need the value to be undefined.
    //  i.e. for the input to show '3.' it needs value={readingInput} to be undefined the
    // onReadingChange needs to handle that it should return early when readingInput is
    // undefined, which is handled by using the INVALID_NUMERIC_INPUTS constant.
    setReadingInput(null);
  }
};

export const handleOnBeforeInput: React.FormEventHandler<HTMLInputElement> = (
  e
) => handleOnBeforeInputNative(e.nativeEvent as InputEvent);

export const handleOnBeforeInputNative = (evt: InputEvent) => {
  if (!noLetters(evt.data ?? '')) {
    evt.preventDefault();
  }
};
